/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Player_Now_PlayingInputs */

const en_mobile_player_now_playing = /** @type {(inputs: Mobile_Player_Now_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Now playing`)
};

const es_mobile_player_now_playing = /** @type {(inputs: Mobile_Player_Now_PlayingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reproduciendo ahora`)
};

/**
* | output |
* | --- |
* | "Now playing" |
*
* @param {Mobile_Player_Now_PlayingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_player_now_playing = /** @type {((inputs?: Mobile_Player_Now_PlayingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Player_Now_PlayingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_player_now_playing(inputs)
	return en_mobile_player_now_playing(inputs)
});